import React, { useEffect, useState, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import CustomPagination from "../../common/custompagination";
import { globalLoader, TrimText } from "../../../../utils/commonfunction";
import {
  TempleRunnerBookingList, CompleteOrder , TempleRunnerPujaImageUpload , TempleRunnerPujaImageList , TempleRunnerPujaImageDelete
} from "../../services/templeRunnerBooking.services";
import Swal from "sweetalert2";
import { SWAL_SETTINGS , showTempleRunnerBookingFilterlist } from "../../../../utils/Constants";


const TempleRunnerBooking = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [globalSearch, setGlobalSearch] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [search, setSearch] = useState({});
  const [currentBookingId, setCurrentBookingId] = useState(null);  

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Temple Bookings"), url: "" },
  ];

  // ================= FETCH BOOKINGS =================
  const fetchBookings = useCallback(() => {
    setLoader(true);

    const formData = new FormData();
    formData.append("page", page);
    formData.append("per_page", itemPerPage);
    formData.append("global_search", globalSearch);
    Object.keys(search).forEach((key) => {
      formData.append(key, search[key]);
    });

    TempleRunnerBookingList(formData)
      .then((res) => {
        setList(res?.data?.list || []);
        setTotalRecords(res?.data?.total_records || 0);
        // console.log(res?.data?.list );
      })
      .finally(() => setLoader(false));
  }, [page, itemPerPage, globalSearch,search]);

  useEffect(() => {
    fetchBookings();
  }, [fetchBookings, refresh]);

  const resetFilter = () => {
    setGlobalSearch("");
    setPage(1);
    prepareSearch();
    setSearch({});
  };

  // ================= ASSIGN RUNNER =================

  const handleMarkComplete = (templeServiceHistoryId) => {
    Swal.fire({
      title: "Mark order as completed?",
      text: "This action cannot be undone",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, complete it",
      cancelButtonText: "No, cancel",
      reverseButtons: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (!result.isConfirmed) return;

      CompleteOrder({
        templeservicehistory_id: templeServiceHistoryId,
      }).then((res) => {
        Swal.fire({
          title: res?.success ? "Completed" : "Failed",
          text: res?.message,
          icon: res?.success ? "success" : "error",
        });

        if (res?.success) {
          setRefresh((prev) => !prev);
        }
      });
    });
  };

  // ================= GROUP BY TEMPLE =================

  const groupedBookings = list.reduce((acc, booking) => {
    const templeName = booking.temple?.templeName || "Unknown Temple";
    acc[templeName] = acc[templeName] || [];
    acc[templeName].push(booking);
    return acc;
  }, {});

  const renderStatus = (status) => {
    const map = {
      pending: "bg-warning",
      upcoming: "bg-primary",
      assigned: "bg-info",
      completed: "bg-success",
      cancelled: "bg-danger",
    };
    return (
      <span
        className={`btn text-white text-capitalize ${map[status] || "bg-secondary"}`}
      >
        {t(status)}
      </span>
    );
  };

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  function viewfunction(data) {
    navigate(`/admin/runner-booking/view/${data}`);
  }

  const openUploadSwal = (bookingId, existingCount = 0) => {
    let selectedFiles = [];
    const maxAllowed = 4;
    const remaining = maxAllowed - existingCount;

    Swal.fire({
      title: "Upload Images",
      html: `
        <input type="file" id="imageInput" accept="image/*" multiple class="form-control" />
        <small>
          Already uploaded: ${existingCount} <br/>
          You can upload max ${remaining} more image(s)
        </small>

        <div id="preview" style="display:flex;gap:10px;flex-wrap:wrap;margin-top:10px"></div>

        <div class="progress mt-3 d-none" id="progressWrapper">
          <div class="progress-bar progress-bar-striped progress-bar-animated"
            id="progressBar" style="width:0%">0%</div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Upload",
      allowOutsideClick: false,

      didOpen: () => {
        const input = document.getElementById("imageInput");
        const preview = document.getElementById("preview");

        input.onchange = () => {
          preview.innerHTML = "";
          selectedFiles = Array.from(input.files);

          if (selectedFiles.length > remaining) {
            Swal.fire(
              "Limit Exceeded",
              `You can upload only ${remaining} more image(s)`,
              "error"
            );
            input.value = "";
            selectedFiles = [];
            return;
          }

          selectedFiles.forEach((file, index) => {
            const wrapper = document.createElement("div");
            wrapper.style.position = "relative";

            const img = document.createElement("img");
            img.src = URL.createObjectURL(file);
            img.style.width = "80px";
            img.style.height = "80px";
            img.style.objectFit = "cover";
            img.style.borderRadius = "6px";

            const btn = document.createElement("button");
            btn.innerHTML = "×";
            btn.className = "btn btn-sm btn-danger";
            btn.style.position = "absolute";
            btn.style.top = "0";
            btn.style.right = "0";

            btn.onclick = () => {
              selectedFiles.splice(index, 1);
              wrapper.remove();
            };

            wrapper.appendChild(img);
            wrapper.appendChild(btn);
            preview.appendChild(wrapper);
          });
        };
      },

      preConfirm: async () => {
        if (selectedFiles.length < 1) {
          Swal.showValidationMessage("Please upload at least 1 image");
          return;
        }

        const formData = new FormData();
        selectedFiles.forEach((file) =>
          formData.append("puja_image", file)
        );
        formData.append("booking_id", bookingId);

        const progressWrapper = document.getElementById("progressWrapper");
        progressWrapper.classList.remove("d-none");

        try {
          await TempleRunnerPujaImageUpload(formData);
        } catch (err) {
          Swal.showValidationMessage(
            err?.response?.data?.message || "Image upload failed"
          );
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Success", "Images uploaded successfully", "success");
        fetchBookings();
      }
    });
  };

  const openViewImagesSwal = async (bookingId) => {
    globalLoader(true);

    try {
      const res = await TempleRunnerPujaImageList(bookingId);
      globalLoader(false);

      const images = res?.data?.images || [];

      if (!Array.isArray(images) || images.length === 0) {
        Swal.fire("No Images", "No puja images found", "info");
        return;
      }

      setCurrentBookingId(bookingId);

      showImageGallery(images, bookingId);

    } catch (err) {
      globalLoader(false);
      Swal.fire("Error", "Failed to load images", "error");
    }
  };

  const showImageGallery = (images, bookingId) => {
    Swal.fire({
      title: "Puja Images",
      width: "800px",
      showConfirmButton: false,
      showCloseButton: true,
      html: `<div id="image-container"
              style="display:flex;flex-wrap:wrap;gap:15px;justify-content:center;">
            </div>`,
      didOpen: () => {
        const container = document.getElementById("image-container");

        images.forEach((img) => {
          const wrapper = document.createElement("div");
          wrapper.style.position = "relative";

          const image = document.createElement("img");
          image.src = img;
          image.style.width = "120px";
          image.style.height = "120px";
          image.style.objectFit = "cover";
          image.style.borderRadius = "8px";
          image.style.cursor = "pointer";

          image.onclick = () => {
            Swal.fire({
              imageUrl: img,
              showConfirmButton: false,
              showCloseButton: true,
              width: "800px"
            });
          };

          const deleteBtn = document.createElement("button");
          deleteBtn.innerHTML = "×";
          deleteBtn.className = "btn btn-danger btn-sm";
          deleteBtn.style.position = "absolute";
          deleteBtn.style.top = "5px";
          deleteBtn.style.right = "5px";

          deleteBtn.onclick = async (e) => {
            e.stopPropagation();

            const confirm = await Swal.fire({
              title: "Delete this image?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes",
            });

            if (!confirm.isConfirmed) return;

            const imageName = img.split("/").pop();

            await TempleRunnerPujaImageDelete(bookingId, imageName);

            wrapper.remove();
            fetchBookings();

            Swal.fire("Deleted!", "", "success");
          };

          wrapper.appendChild(image);
          wrapper.appendChild(deleteBtn);
          container.appendChild(wrapper);
        });
      },
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="card custom-card">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h6 className="main-content-label">{t("Temple Booking")}</h6>
            <div className="d-flex align-items-center">
              <div className="form-group mb-0 me-3">
                <div className="form-group mb-0 rangepicker_container filter_design">
                  <i className="fa fa-search calender_icon"></i>
                  <input
                    type="search"
                    className="form-control"
                    value={globalSearch}
                    placeholder={t("input_placeholder_search")}
                    onChange={(e) => setGlobalSearch(e.target.value)}
                  />
                </div>
              </div>
                <div className="me-3">
                  <div className="form-group mb-0 filter_icon_container filter_design">
                    <i className="fa fa-filter mr-2 filter_icon"></i>
                    <div className="select-down-arrow">
                      <select
                        className="form-control cp"
                        onChange={(e) => prepareSearch("status", e.target.value)}
                        id="defaultstatus"
                      >
                        {showTempleRunnerBookingFilterlist.map((option, i) => (
                          <option key={i} value={option.status__id}>
                            {t(option.name)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>         
                <button
                type="reset"
                className="btn btn-warning me-2"
                onClick={resetFilter}
              >
                {t("btn_reset_filter")}
              </button>
            </div>
          </div>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>User</th>
                <th>Service</th>
                <th>Duration</th>
                <th>Status</th>
                <th>Image</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loader ? (
                <tr>
                  <td colSpan={9} className="text-center">
                    <Loader />
                  </td>
                </tr>
              ) : list.length === 0 ? (
                    <tr>
                      <td colSpan={9} className="text-center">
                        {t("msg_no_records")}
                      </td>
                    </tr>
              ) : (
                Object.keys(groupedBookings).map((temple, i) => (
                  <React.Fragment key={temple + i}>
                    <tr>
                      <td colSpan={9} className="fw-bold bg-light">
                        {temple}
                      </td>
                    </tr>
                    {groupedBookings[temple].map((b, idx) => (
                      <tr key={b._id}>
                        <td>{idx + 1}</td>
                        <td>{b.booking_user?.name || "-"}</td>
                        <td>{TrimText(b.service?.name || "-", 20)}</td>
                        <td>{b.service?.duration || "-"} Mintues</td>
                        <td>
                            {b.order_status === "assigned" ? (
                              <button
                                className="btn btn-success btn-sm"
                                onClick={() => handleMarkComplete(b._id)}
                              >
                                Mark as Complete
                              </button>
                            ) : (
                              renderStatus(b.order_status)
                            )}
                        </td>
                        <td>
                          <button
                            className="btn btn-info btn-sm me-2"
                            onClick={() => openUploadSwal(b._id,b.puja_image_count)}
                            disabled={b.order_status !== "completed"}
                          >
                            Upload
                          </button>
                          <button
                            className="btn btn-secondary btn-sm position-relative"
                            onClick={() => openViewImagesSwal(b._id)}
                            disabled={b.order_status !== "completed"}
                          >
                            View Image

                            {b.order_status === "completed" && b.puja_image_count > 0 && (
                              <span
                                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                              >
                                {b.puja_image_count}
                              </span>
                            )}
                          </button>
                        </td>
                        <td>
                          <button
                            className="btn ripple btn-main-primary signbtn me-2"
                            onClick={() => {
                              viewfunction(b._id);
                            }}
                          >
                            {t("btn_view")}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
          <div id="example1_info" role="status" aria-live="polite">
            <b>
              {t("msg_total_records")} : {totalRecords}
            </b>
          </div>
          {totalRecords > 0 && (
            <CustomPagination
              datalength={totalRecords}
              itemperpage={itemPerPage}
              currentPage={page}
              setPage={setPage}
              pageRoute={[
                {
                  name: "PageTable",
                  path: "/admin/temple-booking/list/1",
                },
              ]}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default TempleRunnerBooking;
